import { OrderDocumentTypeEnum } from '@/eshop/gql/graphql'
import { useK2Setup } from '@/eshop/hooks/useK2Setup'
import { getOrderDocument } from '@/eshop/queries'
import { downloadBase64File } from '@/eshop/utils/client'
import { useMutation } from '@tanstack/react-query'

interface Props {
    onMutate?: (rid: string) => void
    onSettled?: (rid: string) => void
}

export function useDownloadInvoice({ onMutate, onSettled }: Props) {
    const k2 = useK2Setup()

    return useMutation({
        mutationKey: ['orderdocument'],
        mutationFn: (invoiceOutRID: string) =>
            getOrderDocument()({
                typeOfDoc: OrderDocumentTypeEnum.Invoice,
                lang: k2.languageId,
                invoiceOutRID,
            }).toPromise(),
        onMutate: (rid) => {
            onMutate?.(rid)
        },
        onSettled: (data, err, rid) => {
            onSettled?.(rid)
            data?.match?.({
                Ok: (v) => {
                    v?.orderDocument?.resultBase64 &&
                        downloadBase64File(rid, v.orderDocument.resultBase64)
                },
                Error: () => {},
            })
        },
    })
}
